<div class="w-full flex flex-column gap-2">
  <div class="w-full flex gap-2">
    <span class="search-input-wrapper flex-1">
      <input
        type="text"
        pInputText
        class="search-input w-full"
        placeholder="Wpisz kod"
        [(ngModel)]="searchPhrase"
        (keyup.enter)="search()"
      />
      <button
        *ngIf="searchPhrase"
        type="button"
        class="search-input-clear"
        aria-label="Wyczyść wyszukiwanie"
        pTooltip="Wyczyść"
        tooltipPosition="bottom"
        (click)="clear()"
        data-clarity-unmask="true"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </span>
    <p-button label="Szukaj" icon="pi pi-search" (onClick)="search()" data-clarity-unmask="true"></p-button>
  </div>


  <ng-container *ngIf="appliedPhrase">
    <fas-service-dynamic-table
      class="mt-2"
      [columns]="ticketColumns"
      [dataMode]="'server'"
      [dataService]="fetchTickets"
      [initialPageSize]="5"
      [resetTrigger]="searchTrigger.asObservable()"
      [columnTemplates]="{
        isUsedTemplate: isUsedTemplateRef,
        usedByTemplate: usedByTemplateRef,
        validDaysTemplate: validDaysTemplateRef,
        oskNameTemplate: oskNameTemplateRef
      }"
    >
      <ng-template #isUsedTemplateRef let-row>
        {{ row.isUsed ? 'Tak' : 'Nie' }}
        <span *ngIf="row.isUsed && row.usedDate">({{ row.usedDate | date: 'dd.MM.yyyy HH:mm' }})</span>
      </ng-template>
      <ng-template #usedByTemplateRef let-row>
        <app-user-account-link
          [email]="row.usedByUserAccountEmail"
          [userGuid]="canOpenAccounts ? row.usedByUserAccountGuid : null"
          [label]="row.usedByUserAccount"
        />
      </ng-template>
      <ng-template #validDaysTemplateRef let-row>
        {{ row.bookAccessPackageValidDays ? row.bookAccessPackageValidDays + ' dni' : 'Bez limitu' }}
      </ng-template>
      <ng-template #oskNameTemplateRef let-row>{{ row.oskName || '—' }}</ng-template>
    </fas-service-dynamic-table>
  </ng-container>
</div>
